<div
	class="wrapper horizontal-shadow content-gutter"
	appLayoutClass
	[class.shadow-visible]="transition === 'open'"
	[class.open]="transition === 'open'"
	[@slideInOut]="transition"
>
	<router-outlet
		name="actionbar"
		(activate)="onActivate($event)"
		(deactivate)="onDeactivate($event)"
	/>
</div>
